export type OrderOverdueDelaySettings = OverdueDelay;
export enum PositionStrategy {
  Incremental = 'Incremental',
  Disabled = 'Disabled',
}

export interface OverdueDelay {
  positionStrategy?: PositionStrategy;
  delayOverdueDays: number;
  delayDuringWeekend: boolean;
  turnOffOverdue: boolean;
  connectionOverdueSettings?: {
    [key: string]: Record<string, FormOverdueDelay>
  }
}

export interface OverdueCompanySettingsDto {
  orderDeliverySettings: {
    positionStrategy: PositionStrategy;
  },
  delayOverdueDays: number;
  delayDuringWeekend: boolean;
  turnOffOverdue: boolean;
  connectionOverdueSettings?: {
    [key: string]: Record<string, FormOverdueDelay>
  }
}

export type FormTaskOverdueDelaySettings = FormOverdueDelay;

export interface FormOverdueDelay {
  delayOverdueDays: number;
  delayDuringWeekend: 'yes' | 'no';
  turnOffOverdue: boolean;
}
